import { Module, VuexModule, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import {
  BASE_URL,
  CAMPAIGN_LIST,
  CAMPAIGN_ADD,
  CAMPAIGN_UPDATE,
  CAMPAIGN_DELETE,
  M_POST,
  M_GET,
  M_PUT,
  M_DELETE
} from '@/utils/api';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

@Module({ name: 'campaign', namespaced: true })
export default class Campaign extends VuexModule {
  @Action({ rawError: true })
  async FetchCampaignList(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_LIST,
        data: criteria,
        method: M_GET,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch campaign list failed');
      return data;
    } catch (err) {
      throw toError(err, 'Fetch campaign list failed');
    }
  }

  @Action({ rawError: true })
  async AddCampaign(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_ADD,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Add campaign failed');
      return data;
    } catch (err) {
      throw toError(err, 'Add campaign failed');
    }
  }

  @Action({ rawError: true })
  async UpdateCampaign(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_UPDATE,
        data: criteria,
        method: M_PUT,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Update campaign failed');
      return data;
    } catch (err) {
      throw toError(err, 'Update campaign failed');
    }
  }

  @Action({ rawError: true })
  async DeleteCampaign(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + CAMPAIGN_DELETE,
        data: criteria,
        method: M_DELETE,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Delete campaign failed');
      return data;
    } catch (err) {
      throw toError(err, 'Delete campaign failed');
    }
  }
}
